<h2>{{title}}</h2>
<div id="chart">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [labels]="chartOptions.labels"
    [responsive]="chartOptions.responsive"
    [dataLabels]="chartOptions.dataLabels"
    [tooltip]="chartOptions.tooltip"
  ></apx-chart>
</div>
